import { Orgao } from "../comum/orgao.model";
import { BaseResourceModel } from "../../models/base-resource.model";

export class TransparenciaTituloDescricaoQuadro extends BaseResourceModel {

  constructor(
    public recebimento_covid_titulo?: string,
    public recebimento_covid_descricao?: string,
    public despesa_covid_titulo?: string,
    public despesa_covid_descricao?: string,
    public arrecadacao_receita_diaria_titulo?: string,
    public arrecadacao_receita_diaria_descricao?: string,
    public recebimento_fonte_recurso_titulo?: string,
    public recebimento_fonte_recurso_descricao?: string,
    public arrecadacao_imposto_titulo?: string,
    public arrecadacao_imposto_descricao?: string,
    public arrecadacao_mensal_titulo?: string,
    public arrecadacao_mensal_descricao?: string,
    public empenho_orcamentario_titulo?: string,
    public empenho_orcamentario_descricao?: string,
    public despesa_empenhada_mensal_titulo?: string,
    public despesa_empenhada_mensal_descricao?: string,
    public liquidacao_orcamentaria_titulo?: string,
    public liquidacao_orcamentaria_descricao?: string,
    public pagamento_orcamentario_titulo?: string,
    public pagamento_orcamentario_descricao?: string,
    public transferencia_orgao_titulo?: string,
    public transferencia_orgao_descricao?: string,
    public transferencia_estadual_titulo?: string,
    public transferencia_estadual_descricao?: string,
    public transferencia_federal_titulo?: string,
    public transferencia_federal_descricao?: string,
    public recebimento_extra_titulo?: string,
    public recebimento_extra_descricao?: string,
    public despesa_extra_titulo?: string,
    public despesa_extra_descricao?: string,
    public despesa_fonte_recurso_titulo?: string,
    public despesa_fonte_recurso_descricao?: string,
    public empenho_restos_titulo?: string,
    public empenho_restos_descricao?: string,
    public pagamento_extra_titulo?: string,
    public pagamento_extra_descricao?: string,
    public liquidacao_restos_titulo?: string,
    public liquidacao_restos_descricao?: string,
    public pagamento_restos_titulo?: string,
    public pagamento_restos_descricao?: string,
    public licitacao_titulo?: string,
    public licitacao_descricao?: string,
    public contrato_titulo?: string,
    public contrato_descricao?: string,
    public consulta_fornecedor_titulo?: string,
    public consulta_fornecedor_descricao?: string,
    public ata_registro_preco_titulo?: string,
    public ata_registro_preco_descricao?: string,
    public fiscais_contrato_titulo?: string,
    public fiscais_contrato_descricao?: string,
    public painel_obra_titulo?: string,
    public painel_obra_descricao?: string,
    public informacao_adicionais_titulo?: string,
    public informacao_adicionais_descricao?: string,
    public despesa_viagem_titulo?: string,
    public despesa_viagem_descricao?: string,
    public equipamento_material_permanente_titulo?: string,
    public equipamento_material_permanente_descricao?: string,
    public operacao_credito_titulo?: string,
    public operacao_credito_descricao?: string,
    public convenio_titulo?: string,
    public convenio_descricao?: string,
    public repasse_terceiro_setor_titulo?: string,
    public repasse_terceiro_setor_descricao?: string,
    public transferencia_institucional_privada_titulo?: string,
    public transferencia_institucional_privada_descricao?: string,
    public remuneracao_servidor_titulo?: string,
    public remuneracao_servidor_descricao?: string,
    public cargo_salario_titulo?: string,
    public cargo_salario_descricao?: string,
    public servidor_publico_credito_titulo?: string,
    public servidor_publico_credito_descricao?: string,
    public servidor_publico_afastado_titulo?: string,
    public servidor_publico_afastado_descricao?: string,
    public planejamento_orcamentario_titulo?: string,
    public planejamento_orcamentario_descricao?: string,
    public conta_publica_titulo?: string,
    public conta_publica_descricao?: string,
    public ordem_cronologica_pagamento_titulo?: string,
    public ordem_cronologica_pagamento_descricao?: string,
    public anexo1_titulo?: string,
    public anexo1_descricao?: string,
    public anexo2_titulo?: string,
    public anexo2_descricao?: string,
    public anexo3_titulo?: string,
    public anexo3_descricao?: string,
    public tributo_arrecadado_titulo?: string,
    public tributo_arrecadado_descricao?: string,
    public anexo_loa_titulo?: string,
    public anexo_loa_descricao?: string,
    public execusao_orcamentaria_titulo?: string,
    public execusao_orcamentaria_descricao?: string,
    public ordem_fornecimento_titulo?: string,
    public ordem_fornecimento_descricao?: string,
    public balancete_mensal_titulo?: string,
    public balancete_mensal_descricao?: string,
    public balanco_titulo?: string,
    public balanco_descricao?: string,
    public anexo_ensino_titulo?: string,
    public anexo_ensino_descricao?: string,
    public anexo_saude_titulo?: string,
    public anexo_saude_descricao?: string,
    public plano_contratacao_anual_titulo?: string,
    public plano_contratacao_anual_descricao?: string,
    public emenda_palamentar_titulo?: string,
    public emenda_palamentar_descricao?: string,
    public dividas_fornecedor_titulo?: string,
    public dividas_fornecedor_descricao?: string,
    public despesa_status_titulo?: string,
    public despesa_status_descricao?: string,
    public orgao?: Orgao,


  ) {
    super();
  }

  static converteJson(json: any): TransparenciaTituloDescricaoQuadro {
    return Object.assign(new TransparenciaTituloDescricaoQuadro(), json);
  }
}
